export class DialogRepository {

    static getAll(type = null) {
        return  JSON.parse(localStorage.getItem("dialogs")) || [];
    }


    static find(id) {
        const all = this.getAll();
        if (!all) return null;

        return all.find(item => item.id === id) || null;
    }


    static findByChatId(chatId) {
        const all = this.getAll();
        if (!all) return null;

        return all.find(item => parseInt(item.chat_id) === parseInt(chatId)) || null;
    }


    static deleteAll() {
        return localStorage.removeItem("dialogs")
    }

    static saveDialogs(dialogs) {
        localStorage.setItem("dialogs", JSON.stringify(dialogs))
    }

}
